import React, { FC } from 'react';
import { Tabs as BaseTabs } from '@material-ui/core';

interface TabsProps {
  onChange: (event: React.ChangeEvent<{}>, newValue: number) => void;
  value: number;
}

const Tabs: FC<TabsProps> = (props) => {
  return (
    <BaseTabs value={props.value} onChange={props.onChange}>
      {props.children}
    </BaseTabs>
  );
};

export default Tabs;
